import CryptoJS from 'crypto-js'
import Rsa from 'node-rsa'
import { select } from 'redux-saga/effects'

import { getPublicCert } from '../selectors'

export function* encryptRsa(text, { encode = 'base64', urlEncode = false } = {}) {
  if (!text) return ''
  const key = yield select(getPublicCert)
  const rsa = new Rsa(key)
  const encrypted = rsa.encrypt(text).toString(encode)
  return urlEncode ? encodeURIComponent(encrypted) : encrypted
}

// Additional encryption functions for tests
export const encrypt = (text, key) => {
  if (!text) return ''
  return CryptoJS.AES.encrypt(text, key).toString()
}

export const decrypt = (encryptedText, key) => {
  if (!encryptedText) return ''
  try {
    const bytes = CryptoJS.AES.decrypt(encryptedText, key)
    const decrypted = bytes.toString(CryptoJS.enc.Utf8)
    if (!decrypted) {
      throw new Error('Invalid key or corrupted data')
    }
    return decrypted
  } catch (error) {
    // biome-ignore lint/style/useTemplate: TODO
    throw new Error('Decryption failed: ' + error.message)
  }
}

export const hashPassword = (password, salt) => {
  return CryptoJS.PBKDF2(password, salt, {
    keySize: 256 / 32,
    iterations: 1000,
  }).toString()
}

export const generateSalt = (length = 16) => {
  return CryptoJS.lib.WordArray.random(length / 2)
    .toString()
    .substring(0, length)
}
